module.exports = __webpack_public_path__ + "img/exampleLoc.f2e3de39.png";